import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import WorkflowSimpleMappingConfigureDrawer from './WorkflowSimpleMappingConfigureDrawer';

const fields = {
  Invoice: [
    { key: 'customer', text: 'Customer', types: ['dropdown - Customers'] },
    { key: 'project', text: 'Sub-Customer', types: ['dropdown - Projects'] },
    { key: 'total', text: 'Total', types: ['text'] },
    { key: 'dueDate', text: 'Due Date', types: ['dateRange'] },
    { key: 'type', text: 'Invoice Type', types: ['dropdown - Custom'] },
    { key: 'creationDate', text: 'Creation Date', types: ['dateTime'] },
    { key: 'privateNote', text: 'Note', types: ['text'] },
  ],
  PO: [
    { key: 'poValue', text: 'PO Value', types: ['form - PO Value', 'table - Materials'] },
    { key: 'vendor', text: 'Vendor', types: ['dropdown - Vendors'] },
    { key: 'materials', text: 'Materials', types: ['table - Materials'] },
    { key: 'memo', text: 'Message to Supplier', types: ['text'] },
    { key: 'privateNote', text: 'Memo', types: ['text'] },
    { key: 'dueDate', text: 'Due Date', types: ['dateRange'] },
  ],
};
const requiredFields = {
  Invoice: new Set(['customer', 'total']),
  PO: new Set(['vendor', 'materials', 'poValue']),
};

function WorkflowQuickBooksConfigureDrawer({
  visible,
  onClose,
  onSubmit,
  sourceName,
  sourceSections = [],
  fieldMappings = {},
  onFieldMappingsChange,
  formTypeName,
  hasTableSelected,
}) {
  const ourRequiredFields = useMemo(() => {
    if (formTypeName === 'Invoice' && hasTableSelected) {
      return new Set(['customer']);
    }
    return requiredFields[formTypeName] ?? new Set();
  }, [formTypeName, hasTableSelected]);

  return (
    <WorkflowSimpleMappingConfigureDrawer
      visible={visible}
      onClose={onClose}
      onSubmit={onSubmit}
      sourceSections={sourceSections}
      fieldMappings={fieldMappings}
      onFieldMappingsChange={onFieldMappingsChange}
      fields={fields[formTypeName] ?? []}
      requiredFields={ourRequiredFields}
      title={(
        <span>
          Configure which fields from this
          {' '}
          <b>{sourceName}</b>
          {' '}
          form are loaded into the QuickBooks
          {' '}
          {formTypeName}
        </span>
    )}
      targetHeader={`${formTypeName} Field`}
    />
  );
}

/* eslint-disable react/forbid-prop-types */
WorkflowQuickBooksConfigureDrawer.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  sourceName: PropTypes.string.isRequired,
  sourceSections: PropTypes.array.isRequired,
  fieldMappings: PropTypes.object.isRequired,
  onFieldMappingsChange: PropTypes.func.isRequired,
  formTypeName: PropTypes.string.isRequired,
  hasTableSelected: PropTypes.bool.isRequired,
};

WorkflowQuickBooksConfigureDrawer.defaultProps = {
  visible: false,
};

export default WorkflowQuickBooksConfigureDrawer;
